/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit, Renderer2} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FORGOT_PASSWORD_REQUEST_SEND, I18nService, UserService} from '../../_services/services';
import {Helpers} from '../../helpers';
import {ToastrService} from 'ngx-toastr';
import {HttpErrorResponse} from '@angular/common/http';
import {BACKGROUND_COLOR, COLOR_PRIMARY_LIGHT} from '../../_enums/constants';

declare var $: any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS GROUPS                                                                                          ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public forgotPasswordFG: FormGroup;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGIC FUNCTIONS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    private formBuilder: FormBuilder,
    private i18n: I18nService,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private userService: UserService
  ) {
    this.renderer.setStyle(document.body, BACKGROUND_COLOR, COLOR_PRIMARY_LIGHT);
  }

  ngOnInit() {
    this.forgotPasswordFG = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]]
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              EMAIL FORM CONTROLS                                                                                   ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get email(): AbstractControl {
    return this.forgotPasswordFG.get('email');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS SUBMITS                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  resetPasswordFormSubmit() {
    if (this.forgotPasswordFG.valid) {
      Helpers.setLoading(true);

      this.userService.forgotPassword(this.forgotPasswordFG.value.email).subscribe(() => {
        Helpers.setLoading(false);
        this.toastr.success(this.i18n.get(FORGOT_PASSWORD_REQUEST_SEND));
      }, (err: HttpErrorResponse) => this.handleError(err));
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}
